import React, { useState } from 'react';
import { AccountDetails, Password, TwoFactor, DeleteAccount } from './components';
import { Translate } from 'react-redux-i18n';
import 'assets/css/account.css';

const Account = () => {
  const [tab, setTab] = useState('profile');

  return (
    <div className="account-page">
      <header className="account-page-header">
        <h1 className="account-page-title">
          <Translate value="account" />
        </h1>
        <p className="account-page-subtitle">
          <Translate value="profile_detail" />
        </p>
      </header>

      <div className="account-tabs" role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'profile'}
          className={`account-tab${tab === 'profile' ? ' active' : ''}`}
          onClick={() => setTab('profile')}
        >
          <Translate value="profile" />
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'password'}
          className={`account-tab${tab === 'password' ? ' active' : ''}`}
          onClick={() => setTab('password')}
        >
          <Translate value="password" />
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'security'}
          className={`account-tab${tab === 'security' ? ' active' : ''}`}
          onClick={() => setTab('security')}
        >
          <Translate value="account_security" />
        </button>
      </div>

      {tab === 'profile' && (
        <>
          <AccountDetails />
          <DeleteAccount />
        </>
      )}
      {tab === 'password' && <Password />}
      {tab === 'security' && <TwoFactor variant="account" />}
    </div>
  );
};

export default Account;
